import { JOURNEY_NAMES } from '../../Lifecycle/shared/labels';

export const JOURNEY_KEYS = Object.keys(JOURNEY_NAMES).filter(
  (key) => key !== 'TX',
);

export type Tone = 'green' | 'amber' | 'red' | 'grey' | 'blue';

export const stagePill = (
  key: string,
  stepName: string | null,
): { text: string; tone: Tone } => {
  switch (key) {
    case 'awaiting_review':
      return { text: 'Waiting on us', tone: 'amber' };
    case 'cleared_no_shift':
      return { text: 'Cleared, no shift yet', tone: 'green' };
    case 'booked_no_worked':
      return { text: 'Booked, not worked yet', tone: 'green' };
    case 'shifts_1_2':
      return { text: '1 to 2 shifts worked', tone: 'green' };
    case 'shifts_3_4':
      return { text: '3 to 4 shifts worked', tone: 'green' };
    case 'activated':
      return { text: 'Activated', tone: 'green' };
    case 'no_tax_type':
      return { text: 'No tax type yet', tone: 'grey' };
    case 'no_step_rows':
      return { text: 'Not started', tone: 'grey' };
    default:
      return { text: stepName || 'Onboarding step', tone: 'grey' };
  }
};

export const exitLabel = (reason: string | null, status: string): string => {
  switch (reason) {
    case 'goal':
      return 'Goal reached';
    case 'window':
      return 'Window ended';
    case 'superseded':
      return 'Replaced by another journey';
    case 'suppressed':
      return 'Cannot contact';
    case 'kill_switch':
      return 'Kill switch off';
    case 'journey_off':
      return 'Journey switched off';
    case 'outside_pilot':
      return 'Outside the pilot area';
    default:
      return reason || status;
  }
};
